import angular from 'angular';
import {inactiveForm} from './inactive-form.component';
import {discardedIdentifiers} from './discarded-identifiers.component';
import {subEntities} from './sub-entity.component';
import {division} from './division.component';
import {billingWarrants} from './billing-warrants.component';
import {routingCodes} from '../principal/routing/routing-code.component';
import {billingAddress} from "../principal/billing-address/billing-address.component";

(function () {
    'use strict';

    angular
        .module('app.kissseller', [])
        .component('sellerInactiveForm', inactiveForm)
        .component('sellerDiscardedIdentifiers', discardedIdentifiers)
        .component('subEntities', subEntities)
        .component('division', division)
        .component('billingWarrants', billingWarrants)
        .component('routingCodes', routingCodes)
        .component('billingAddress', billingAddress);

})();
